module.exports = __webpack_public_path__ + "sample-shoe1.845575a79fe99f1b5bf926929a40d60d.png";